import { Code2, Database, Server, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

const About = () => {
  const technologies = [
    "React",
    "Next.js",
    "Node.js",
    "Express",
    "TypeScript",
    "Zustand",
    "PostgreSQL",
    "Docker",
    "NGINX",
  ];

  return (
    <section id="about" className="py-24 bg-secondary/50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="text-4xl font-bold mb-6 text-center"
          >
            About <span className="text-gradient">Me</span>
          </motion.h2>
          
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <motion.div 
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="space-y-6"
            >
              <p className="text-lg text-muted-foreground leading-relaxed">
                I solve complex problems with clean, scalable code. With 4+ years building full-stack web systems, I focus on delivering <strong className="text-foreground">high-performance solutions</strong> that drive real business value — from React interfaces to Node.js backends, database optimization to deployment architecture.
              </p>
              
              <p className="text-lg text-muted-foreground leading-relaxed">
                I thrive in collaborative environments and excel at translating requirements into robust, maintainable systems. Whether it's architecting microfrontends or optimizing PostgreSQL queries, I bring both technical depth and pragmatic problem-solving.
              </p>

              <p className="text-sm text-muted-foreground italic flex items-center gap-2 pt-2">
                <Sparkles className="w-4 h-4 text-primary" />
                Outside of code, I enjoy boxing and analyzing market data.
              </p>

              <div className="flex flex-wrap gap-4 pt-4">
                <div className="flex items-center gap-2 text-muted-foreground">
                  <Code2 className="w-5 h-5 text-primary" />
                  <span className="text-sm">Clean Code</span>
                </div>
                <div className="flex items-center gap-2 text-muted-foreground">
                  <Server className="w-5 h-5 text-primary" />
                  <span className="text-sm">Scalable Systems</span>
                </div>
                <div className="flex items-center gap-2 text-muted-foreground">
                  <Database className="w-5 h-5 text-primary" />
                  <span className="text-sm">Performance</span>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <h3 className="text-xl font-semibold mb-4 text-primary">Tech Stack</h3>
              <div className="flex flex-wrap gap-3">
                {technologies.map((tech, idx) => (
                  <motion.span
                    key={tech}
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3, delay: 0.4 + idx * 0.05 }}
                    whileHover={{ scale: 1.05, borderColor: "hsl(var(--primary))" }}
                    className="px-4 py-2 bg-card border border-border rounded-lg text-sm font-mono hover:border-primary transition-all cursor-default"
                  >
                    {tech}
                  </motion.span>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
